import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { GenericGet } from '@/_shared/types';
import { UserAuthErrorType } from '@/swagger/constants/slash-enums';
import { API_ORGANIZATIONS_ORGANIZATIONID_USERS_AUTHORIZE_PATH_KEY } from '@/swagger/constants/slash-keys';
import { API_GET_USER_AUTHORIZE, KEY_GET_USER_AUTHORIZE } from '../constants';
import { getCurrentOrganization } from '../selectors';

export type CallParamsGetUserAuthorize = {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponseGetUserAuthorize = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_USERS_AUTHORIZE_PATH_KEY
>['response']['body'];

type CallErrorGetUserAuthorize = {
  type?: `${UserAuthErrorType}`;
  message?: string;
  status?: number;
};

type CallSelectorsGetUserAuthorize = {
  blockingErrorType: `${UserAuthErrorType}` | undefined;
  hasBlockingError: boolean;
};

export const getUserAuthorizeCall = createGeneralCall<
  CallParamsGetUserAuthorize,
  CallResponseGetUserAuthorize,
  CallErrorGetUserAuthorize,
  CallSelectorsGetUserAuthorize
>({
  id: KEY_GET_USER_AUTHORIZE,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_GET_USER_AUTHORIZE(org as unknown as string);
  },
  method: 'get',
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  selectors: {
    blockingErrorType: ({ selectors }) => createSelector(selectors.error, error => error?.type),
    hasBlockingError: ({ selectors }) =>
      createSelector(selectors.error, error => Boolean(error?.type)),
  },
});
